/** @format */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { lazy, Suspense } from 'react';
import { NavigationProvider } from '@context/navigation-context';
import { StateProvider } from '@context/state-context';
import { useWindowSize } from '@hooks/use-window-size';
import Loader from '@components/loader';
import Breadcrumb from '@components/breadcrumb';
import { contactFormFields } from '@forms/form-types/contact-form/contact-form-fields';
import { TranslationProvider } from '@context/translation-context';

/**
 * Lazy Load Components.
 */
const PrimaryNavigationWrapper = lazy(
  () => import(/* webpackChunkName: "mega-menu" */ '@components/mega-menu')
);

const ResponsiveNavigationWrapper = lazy(
  () =>
    import(
      /* webpackChunkName: "responsive-navigation-wrapper" */ '@components/responsive-menu'
    )
);

const AuxiliaryNavigation = lazy(
  () =>
    import(
      /* webpackChunkName: "auxiliary-navigation" */ '@components/auxiliary-navigation'
    )
);

const ContextFormContainer = lazy(
  () =>
    import(
      /* webpackChunkName: "context-form-container" */ '@forms/form-components/form-containers/context-form-container'
    )
);

const LanguageSelector = lazy(
  () =>
    import(
      /* webpackChunkName: "language-selector" */ '@components/language-selector'
    )
);

/**
 * Header.
 */
const Header = (): JSX.Element => {
  const windowSize = useWindowSize();

  /**
   * Render.
   */
  return (
    <NavigationProvider>
      <StateProvider>
        <TranslationProvider>
          {windowSize.width > 0 && windowSize.width < 1440 ? (
            <Suspense fallback="">
              <ResponsiveNavigationWrapper />
            </Suspense>
          ) : (
            <Suspense fallback="">
              <AuxiliaryNavigation location={`top-header-bar`} />
              <PrimaryNavigationWrapper />
            </Suspense>
          )}
          <Breadcrumb />
          <Suspense fallback="">
            <LanguageSelector />
          </Suspense>
          <Suspense fallback="">
            <ContextFormContainer
              formId={1094}
              formFields={contactFormFields}
              formType={`context-contact-form-header`}
              formTitle={`Contact Us`}
            />
          </Suspense>
        </TranslationProvider>
      </StateProvider>
    </NavigationProvider>
  );
};
export default Header;
